import i18next, { i18n } from 'i18next'
import moment from 'moment'
import React from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { div, mk_widget, none, stateful, Widget } from 'widgets-for-react'
import { jsxToWidget } from '../components/cms/blocks/utils.gen'
import { AppState } from '../components/cms/state/types.gen'
import { emptyAppState, PublicSiteState } from '../components/public_site.main.mod'
import { application } from '../components/public_site/application.mod'
import { country } from '../components/public_site/custom_pages/country_page'
import { search } from '../components/public_site/custom_pages/custom_pages.mod'
import { PublicSiteCustomRoutes } from '../components/public_site/custom_pages/types.mod'
import { notfound_page } from '../components/public_site/templates/error_page.mod'
import { footer } from '../components/public_site/templates/footer.mod'
import { header } from '../components/public_site/templates/header.mod'
import { loader } from '../components/public_site/templates/loader.mod'
import { page } from '../components/public_site/templates/page.mod'
import { regionSwitchWidget } from '../components/public_site/templates/regionSwitch/regionSwitchWidget/regionSwitchWidget.mod'
import de from '../locales/de'
import en from '../locales/en'
import nl from '../locales/nl'
import ng from '../locales/ng'


const i18n = function<I> (options: i18next.InitOptions) {
  i18next.init(options)
  return function(children: JSX.Element): Widget<I> {
    return jsxToWidget<I>(
      <I18nextProvider i18n={ i18next }>
        { children }
      </I18nextProvider>
    )
  }
}

function getScrollPercent() {
  var documentElement = document.documentElement,
      body = document.body,
      scrollTop = Math.max(documentElement.scrollTop, body.scrollTop),
      scrollHeight = Math.max(documentElement.scrollHeight, body.scrollHeight) - documentElement.clientHeight;
  return Math.min(Math.max(Math.round(scrollTop / scrollHeight * 100), 0));
}

function ShouldUpdateScroll(){
  let now = moment()
  let diff = moment(now.diff(prev_time))
  if (diff.milliseconds() > 200) {
    prev_time = now
    let current_scroll = getScrollPercent()
    if (current_scroll > last_scroll) {
      last_scroll = current_scroll
    } else {
      return false
    }
    return true
  }
  return false
}

function UpdateScrollDataLayer(){
  if(ShouldUpdateScroll()){
    if(last_scroll < 0) return
    window.dataLayer.push({
      event: "event.fccorporate", category: "Scroll", action: window.location.pathname, label: last_scroll
    });
  }
}

let state : PublicSiteState | "none" = "none"
let prev_time = moment()
let last_scroll = -1



const bootstrap = () =>
  ReactDOM.render(
    i18n<AppState<PublicSiteState, PublicSiteCustomRoutes>>({
      lng: window.wp.language,
      debug: false,
      initImmediate: true,
      resources: { nl, en, de, ng }
    })(
      stateful<AppState<PublicSiteState, PublicSiteCustomRoutes>>()(
        s =>
          div<AppState<PublicSiteState, PublicSiteCustomRoutes>>({className: 'wrap'})([
            mk_widget({run: set_state => {
              if(s.state.page.page.kind == "loaded"){
                state = s.state
              }
              return <>
                {application(
                  { rootpath: '', rootpath_to_ignore: '/portal', login_address: '/portal' },
                  regionSwitchWidget,
                  header,
                  footer,
                  notfound_page,
                  loader,
                  page,
                  { search, country }
                )(s).run(set_state)}
              </>
          }})
        ])
      )({
        current_widget: none(),
        route: {
          kind: '404'
        },
        state: emptyAppState(page)
      }).run(_ => null)
    ).run(_ => null),
    document.getElementById('react-content'),
    () => {
      document.addEventListener("wheel", function(event) {

        UpdateScrollDataLayer()
      })
      document.addEventListener("scroll", function(event) {

        UpdateScrollDataLayer()
      })
    }
  )

document.addEventListener('DOMContentLoaded', () => bootstrap())
